import styled from "styled-components";
import {ProfileWrapperDefaultBox} from "./profile-wrapper.default.box";

export const ProfileWrapperMrGreenBox = styled(ProfileWrapperDefaultBox)`
    background-color: transparent;
    margin: 5rem 0 0 0;
    background-color: ${({theme}) => theme.colors.backgroundDark};
    background: radial-gradient(circle at top, transparent 0, transparent 3.4rem, ${({theme}) => theme.colors.backgroundDark} 3.4rem, ${({theme}) => theme.colors.backgroundDark} 100%);
`;
